import React from "react"
import { Button } from "react-bootstrap"
export const ORIGINAL = "Original"
export const FRAMELESS = "Frameless"

export const makePreviewAndCopyLinkColumns = ({ makeUrl, neededAttr, width = 60 }) => {
    let relevantFields = ["id", "_extra"]
    if (neededAttr) {
        relevantFields = relevantFields.concat(neededAttr)
    }
    return [
        {
            name: "Preview Link",
            field: relevantFields,
            display: (id, extra, neededValue) => {
                const domain = extra.get("action_center_domain")
                const url = makeUrl({ domain, id, [neededAttr]: neededValue, extra })

                return (
                    <a href={url} target="_blank" rel="noreferrer">
                        {" "}
                        rel="noreferrer"
                        <Button className="table-button" variant="danger" block>
                            Preview Link
                        </Button>
                    </a>
                )
            },
            width,
        },
        {
            name: "Copy Embed Code",
            field: relevantFields,
            display: (id, extra, neededValue) => {
                const domain = extra.get("action_center_domain")
                const buttonId = `copy-link-button-${id}`

                const embedOptionSwal = async () => {
                    const promptFrameless = await swal({
                        text: "Copy embed code with original page or frameless?",
                        buttons: {
                            original: { text: "Original", value: ORIGINAL },
                            frameless: { text: "Frameless", value: FRAMELESS },
                        },
                    })

                    if (promptFrameless) {
                        // Use choice from swal to create  page iframe code
                        const url = makeUrl({
                            domain,
                            id,
                            [neededAttr]: neededValue,
                            frameless: promptFrameless,
                            extra,
                        })
                        const iFrameCode = `<iframe src="${url}" style="border-radius:4px;border:1px solid #1a2d18; width:100%; min-height: 800px;"></iframe>`

                        // Create a dummy html element, populate with iframe code, copy to clipboard, and remove html element
                        const copyTextarea = document.createElement("textarea")
                        copyTextarea.innerText = iFrameCode
                        document.body.appendChild(copyTextarea)
                        copyTextarea.select()
                        document.execCommand("copy")
                        copyTextarea.remove()

                        // Set button text to reflect that code is copied
                        const button = document.getElementById(buttonId)
                        button.innerText = "Copied!"
                    }
                }

                return (
                    <Button className="table-button" id={buttonId} variant="primary" onClick={embedOptionSwal} block>
                        Copy Embed Code
                    </Button>
                )
            },
            width,
        },
    ]
}
